import { SpecialOfferProps } from '../types';
import { Box } from '@mui/system';
import BundlePrice from '../../Bundles/BundlePrice';
import { EBundlesInternalViewModel } from '../../Helper/enums';
import { StyledPipaSpecialOffer } from './style';
import { PipaSaleBadge } from '../../Badge/Sale/PipaSaleBadge';

const SpecialOffer = ({
  price,
  productsList,
  backgroundColor,
  backgroundImage,
  selectOffer,
  salePercentage = 0,
  salePercentageDisplayType,
  isFree,
  collectText,
}: SpecialOfferProps) => {
  return (
    <StyledPipaSpecialOffer
      onClick={selectOffer}
      backgroundColor={backgroundColor}
      backgroundImage={backgroundImage}
    >
      <Box className="container">
        {productsList.length > 0 && (
          <Box className="products">
            {salePercentage > 0 && (
              <PipaSaleBadge
                salePercentage={salePercentage}
                salePercentageDisplayType={salePercentageDisplayType}
              />
            )}
            <Box className="products-container">
              <Box className="products-container--main-image">
                <img
                  src={productsList[0].images.product}
                  alt="main-product"
                  className="image"
                />
              </Box>
              <Box className="products-container--products">
                <Box
                  className="product--main"
                  style={{
                    color: productsList[0].textFontColorHex || '#FFF',
                  }}
                >
                  {productsList[0].quantityDisplay || '100'}
                  {salePercentage > 0 && (
                    <p className="product--main__stroked">
                      {productsList[0].strokedSaleQuantity}
                    </p>
                  )}
                </Box>
                {productsList.length > 1 && (
                  <Box className="product--sub-list">
                    {productsList.slice(1, 3).map((product, i) => (
                      <Box
                        className="product--sub-list--item"
                        key={i}
                        style={{ color: product.textFontColorHex || '#FFF' }}
                      >
                        <Box className="sub-image">
                          <img
                            className="image"
                            src={product.images.product}
                            alt="coin"
                          />
                        </Box>
                        {product.quantityDisplay || '100'}
                      </Box>
                    ))}
                  </Box>
                )}
              </Box>
            </Box>
          </Box>
        )}
        <BundlePrice
          price={price}
          type={EBundlesInternalViewModel.PIPA}
          isFree={isFree}
          buttonText={collectText}
        />
      </Box>
    </StyledPipaSpecialOffer>
  );
};

export default SpecialOffer;
